<template>
    <form class="create-form">
        <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
            <Preloader />
        </div>

        <div class="flex flex-col gap-4 mt-4">
            <div class="relative col-span-6">
                <label for="form-question" class="form-label">
                    Название вопроса
                    <sup v-if="v$.form.question.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.question.$errors.length" for="form-question" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.question.$errors[0].$message) }}
                </label>
                <input
                    id="form-question"
                    v-model="form.question"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.question.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                    :data-value="form.question"
                />
            </div>
            <div :class="{ 'form-editor-error': v$.form.question.$errors.length }">
                <label for="form-answer" class="form-label">
                    Описание вопроса
                    <sup v-if="v$.form.question.required" class="text-theme-6">*</sup>
                </label>
                <CustomWyswig id="form-answer" v-model="form.answer" />
            </div>
        </div>

        <div class="col-span-12 flex items-center justify-end mt-5">
            <router-link :to="{ name: 'faq' }" class="btn btn-secondary w-24 mr-2 mb-2">Отмена</router-link>
            <button type="submit" class="btn btn-primary mb-2 mr-2" @click.prevent="saveAndQuit">
                Сохранить и выйти
            </button>
            <button type="submit" class="btn btn-primary mb-2" @click.prevent="saveAndEdit">Сохранить</button>
        </div>
    </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import CustomWyswig from '@/components/base/custom-wyswig/Main';
import { helper as $h } from '@/utils/helper';
import { errorResponse } from '@/mixins/form/form-mixin';
import { formPreparation } from '@/utils/object-to-form-data';

export default {
    name: 'Create',
    components: { CustomWyswig },
    mixins: [errorResponse],
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            loading: false,
            form: {
                question: '',
                answer: '',
            },
        };
    },

    validations() {
        return {
            form: {
                question: { required },
                answer: { required },
            },
        };
    },

    mounted() {
        this.$store.commit('main/setPageHeader', 'Создать вопрос и ответ');
    },

    methods: {
        async save() {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            this.loading = true;
            this.form.seo = this.seo;

            try {
                const formData = formPreparation(this.form, { nullsAsUndefineds: false, imagesAsObject: true });
                const { data } = await this.axios.post('/faq', formData);
                this.$notify(data.message);
                this.loading = false;
                return true;
            } catch (ex) {
                this.errorResponse(ex);
                this.loading = false;
                return false;
            }
        },
        async saveAndQuit() {
            const success = await this.save();
            if (success) this.$router.push({ name: 'faq' });
        },
        async saveAndEdit() {
            const success = await this.save();
            if (success) this.$router.push({ name: 'faq', query: { id: data.data.id } });
        },

        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
    },
};
</script>
